import {IMachinery} from "./iMachinery";

export enum TrackerModel {
    ST_902 = 'ST_902',
    ST_902_MINI = 'ST_902_MINI',
    MICODUS_MV_33 = 'MICODUS_MV_33',
    GALILEO_SKY_10_1_CAN = 'GALILEO_SKY_10_1_CAN',
    GALILEO_SKY_10_2_CAN = 'GALILEO_SKY_10_2_CAN',
    VEGA_1_CAN = 'VEGA_1_CAN',
    VEGA_3_CAN = 'VEGA_3_CAN',
    /** Вся серия автономных маяков Вега MX (MX500/MX510/MX810) — одна запись. */
    VEGA_MX = 'VEGA_MX',
}

export const TRACKER_MODEL_OPTIONS: Array<{
    id: number | string;
    title: string | number
}> = Object.values(TrackerModel).map(
    (v) => ({id: v, title: v}),
);

export enum ProtocolId {
    SINOTRACK = 'SINOTRACK',
    GALILEOSKY = 'GALILEOSKY',
    MICODUS = 'MICODUS',
    UNKNOWN = 'UNKNOWN',
    WIALON_IPS = 'WIALON_IPS',
    WIALON_COMBINE = 'WIALON_COMBINE',
}

export enum TrackerStatus {
    NEW = 'NEW',
    ACTIVE = 'ACTIVE',
    FROZEN = 'FROZEN',
    DISABLED = 'DISABLED',
}

/** Роль устройства: штатный трекер или автономный аварийный маяк. */
export enum TrackerKind {
    MAIN = 'MAIN',
    BEACON = 'BEACON',
}

export const TRACKER_KIND_OPTIONS: Array<{ id: string; title: string }> = [
    {id: TrackerKind.MAIN, title: 'Основной'},
    {id: TrackerKind.BEACON, title: 'Маяк'},
];

export const TRACKER_PROTOCOL_OPTIONS: Array<{
    id: number | string;
    title: string | number
}> = Object.values(ProtocolId).map(
    (v) => ({id: v, title: v}),
);

export const TRACKER_STATUS_OPTIONS: Array<{
    id: number | string;
    title: string | number
}> = Object.values(TrackerStatus).map(
    (v) => ({id: v, title: v}),
);

export interface INewTracker {
    imei: string;
    model: TrackerModel;
    protocol: ProtocolId;
    phone: string;
    password: string,
    /** Роль устройства; бэкенд при отсутствии ставит MAIN (default колонки). */
    kind: TrackerKind;
}

// Одна оплата SIM. Суммы — копейки (bigint-строка с бэка).
export interface ITrackerPayment {
    id: string;
    paid_at: string;
    amount: string;
}

// Расчётный блок оплаты SIM, приходит с бэка (в БД не хранится).
export interface ISimPayment {
    balance: string;
    days_until_payment: number | null;
    next_payment_date: string | null;
    last_payment: { paid_at: string; amount: string } | null;
    payments: ITrackerPayment[];
}

// Данные для добавления новой оплаты (amount — копейки-строка).
export interface INewTrackerPayment {
    amount: string;
    paid_at: string;
}

export interface ITracker extends INewTracker {
    id: string;
    author_email: string;
    created_at: Date;
    updated_at: Date;
    machinery?: IMachinery;
    status: TrackerStatus;
    monthly_tariff: string;
    sim_payment?: ISimPayment;
    /** Машина, где трекер стоит аварийным маяком; null — не привязан. Админка. */
    backup_machinery?: IMachinery | null;
}

export const emptyTracker: INewTracker = {
    imei: "",
    model: TrackerModel.GALILEO_SKY_10_1_CAN,
    protocol: ProtocolId.GALILEOSKY,
    password: "",
    phone: "",
    kind: TrackerKind.MAIN,
}

export const defaultTracker: ITracker = {
    ...emptyTracker,
    id: "",
    author_email: "",
    status: TrackerStatus.NEW,
    monthly_tariff: "0",
    created_at: new Date(),
    updated_at: new Date(),
}

